import { XMarkIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import ReactSelect from "react-select";
import { Actions as ACTIONS } from "../../../store/actions/employeeActions";
import { toTitleCase } from "../../common/validation/Validators";
import { useState } from "react";
import { useMemo } from "react";
import DatePicker from "react-datepicker";
import { addYears, format, parse, subYears } from "date-fns";
import { DateInputFormat, handleRawDate } from "@/common/DateComponents";
import { useEffect } from "react";
import { useLogValue } from "@/helpers/ReactHooks";

const required = {
	delete: [],
	terminate: ["terminationDate"],
};

const DeleteEmployeeDetailsModal = ({
	isModalOpen,
	tab,
	closeModal,
	modalSaving,
	employee,
	item,
	deleteEmployeeDetails,
	action = "delete",
}) => {
	const [data, setData] = useState({});
	useEffect(() => {
		if (isModalOpen) return;
		setData({});
	}, [isModalOpen]);

	const updateField = (name, value) => {
		setData({
			...data,
			[name]: value,
		});
	};
	const requiredFields = useLogValue(required[action]);

	const hasRequired = requiredFields.every((field) => data[field]);

	const verb = action.endsWith("e") ? action.slice(0, action.length - 1) + "ing" : action;

	if (!isModalOpen) return null;
	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "40%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">
								{toTitleCase(action)} {tab}
							</h3>
						</div>

						<div className="block-content">
							<DeletePrompt {...{ action, tab, item, employee }} />
							<TerminatePrompt {...{ action, tab, data, updateField, item }} />

							<div className="col-xs-12 form-container">
								<button
									className="pull-right btn btn-danger"
									onClick={() => deleteEmployeeDetails({ id: item.value, tab, body: data })}
									disabled={modalSaving || !hasRequired}
								>
									{`${toTitleCase(modalSaving ? verb : action)} ${toTitleCase(tab)} ${
										modalSaving ? "..." : ""
									}`}
								</button>
							</div>
						</div>
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

function DeletePrompt({ action, tab, item, employee }) {
	return (
		<div className="col-xs-12">
			Are you sure you'd like to {action} {employee.givenName}'s {tab}?
			<ReactSelect
				isDisabled={true}
				value={item}
			/>
		</div>
	);
}

function TerminatePrompt({ action, tab, updateField, data, item }) {
	if (action !== "terminate") return null;

	const { terminationDate } = data;
	return (
		<div className="col-xs-12">
            <br></br>
            Choose your employee's termination date.
			If payslips were issued that include pay after the date of termination they are not automatically
			updated/calculated. Additional final pay may be due.
			<label
				htmlFor="terminationDate"
				className="mt-4"
			>
				Termination Date
			</label>
			<DatePicker
				autoComplete="off"
				dateFormat="do MMM yyyy"
				minDate={item.start ? parse(item?.start, "yyyy-MM-dd", new Date()) : subYears(new Date(), 100)}
				maxDate={addYears(new Date(), 14)}
				wrapperClassName="full-width"
				required={true}
				className="form-control form-input"
				customInput={<DateInputFormat />}
				onChange={(date) => {
					updateField("terminationDate", date ? format(date, "yyyy-MM-dd") : undefined);
				}}
				onChangeRaw={(e) => {
					handleRawDate(e.target.value, (date) => {
						updateField("terminationDate", date ? format(date, "yyyy-MM-dd") : undefined);
					});
				}}
				strictParsing
				selected={terminationDate && parse(terminationDate, "yyyy-MM-dd", new Date())}
			/>
		</div>
	);
}

const mapStateToProps = (state, ownProps) => {
	const { departments: departmentList, jurisdiction } = state.company?.settings;

	const departmentOptions = departmentList?.map((dep) => ({
		value: dep.id,
		label: dep.name,
	}));

	return {
		isModalOpen: !!state.employee?.deleteDetailsModal,
		modalSaving: state.employee?.deleteDetailsModal?.saving,
		employee: state.employee?.agreementInfo?.employeeDetails,
		tab: state.employee?.deleteDetailsModal?.tab,
		item: state.employee?.deleteDetailsModal?.item,
		action: state.employee?.deleteDetailsModal?.action,
		departmentOptions,
	};
};
const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(ACTIONS.deleteDetailsModal({})),
	deleteEmployeeDetails: ({ id, tab, body }) => dispatch(ACTIONS.deleteEmployeeDetails({ id, tab, body })),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteEmployeeDetailsModal);
